import Stimp from "stimp/lib/index";
import { config } from "../../config";

export class TheList extends Stimp.DOMInteractModule {
  constructor(app, name, initState = {}, depends = []) {
    super(app, name, initState = {
      isLoading: false,
      portion: 1,
      hasNext: true,
      isFiltersOpen: false,
    }, depends);

    this.onAfterDomInit(() => {
      if (this.dom.loadMore) {
        this.dom.loadMore.addEventListener('click', () => {
          this.loadNextPortion();
        });
      }

      this.setState({
        isFiltersOpen: $(this.dom.filters).css('display') !== 'none'
      });

      this.dom.toggleFiltersButton.addEventListener('click', () => {
        this.setState({
          isFiltersOpen: !this.getState().isFiltersOpen,
        });
      });

      this.dom.closeFiltersButton.addEventListener('click', () => {
        this.setState({
          isFiltersOpen: false,
        });
      });

      if (this.dom.root.getAttribute('data-is-any-applied') !== null) {
        this.runInitAnimation();
      }
    });
  }

  runInitAnimation() {
    setTimeout(() => {
      let headerHeight = $('header').hasClass('sticky') ? $('header').height() : $('header').height() / 2;
      $('html, body').animate({
        'scrollTop': $(this.dom.root).offset().top - headerHeight - 20
      }, 1000)
    }, 300)
  }

  getRequestParams() {
    let searchParams = new URLSearchParams(window.location.search.slice(1));
    let params = {};

    for (let [key, value] of searchParams.entries()) {
      let isArray = key.endsWith("[]");
      let paramKey = isArray ? key.slice(0, key.length - 2) : key;
      if (isArray) {
        params[paramKey] = [
          ...(params[paramKey] || []),
          value,
        ]
      } else {
        params[paramKey] = value;
      }
    }

    return params;
  }

  loadNextPortion() {
    const { isLoading, portion, hasNext } = this.getState();
    if (isLoading || !hasNext) {
      return;
    }

    const params = {
      ...this.getRequestParams(),
      page: portion + 1,
    };

    this.setState({
      isLoading: true,
    });

    $.ajax(config.wpAjaxUrl, {
      method: 'post',
      data: {
        action: this.dom.root.getAttribute('data-wp-ajax-action'),
        ...params,
      }
    }).then((result) => {
      const { count, rendered } = result;
      this.setState({
        portion: params.page,
        isLoading: false,
        hasNext: count > 11,
      });
      this.renderNextPortion(rendered);
    }).catch((e) => {
      console.error(e);
    })
  }

  renderNextPortion(htmlStr = '') {
    let htmlEntities = $(`<div>${htmlStr}</div>`).children().toArray();
    htmlEntities.forEach((el, i) => {
      $(el).addClass('pre-show');
      $(this.dom.content).append($(el));
      setTimeout(() => {
        $(el).addClass('show');
      }, i * 100);
    });
  }

  onUpdateIsLoading(value, prevValue) {
    if (value) {
      $(this.dom.loadMore).text($(this.dom.loadMore).attr('data-loading-text')).prop('disabled', true);
    } else {
      $(this.dom.loadMore).text($(this.dom.loadMore).attr('data-default-text')).prop('disabled', false);
    }
  }

  onUpdateHasNext(value, prevValue) {
    if (value) {
      $(this.dom.loadMore).show();
    } else {
      $(this.dom.loadMore).hide();
    }
  }

  onUpdateIsFiltersOpen(open) {
    if (!open) {
      $(this.dom.filters).slideUp();
    } else {
      $(this.dom.filters).slideDown();
    }
  }
}